<!--  <el-row>
     <el-col :span="24" class="paginationBox">
       <el-button @click="firstPageClick" :disabled="total<10">首页</el-button>
       <el-pagination
         @current-change="handleCurrentChange"
         :current-page.sync="currentPage"
         background
         prev-text="上一页"
         next-text="下一页"
         layout="prev, pager, next"
         :total="total">
       </el-pagination>
       <el-button @click="lastPageClick" :disabled="total<10">尾页</el-button>
       <span class="totaltext">共<i>{{total<10?1:(total%10===0?total/10:parseInt(total/10)+1)}}</i>页</span>
       <span class="totaltext">共<i>{{total}}</i>条记录</span>
     </el-col>
   </el-row>-->
<template>
  <div :class="{'hidden':hidden}" class="pagination-container">
    <el-button @click="firstPageClick" :disabled="total<=10">首页</el-button>
    <el-pagination
      :background="background"
      :current-page.sync="currentPage"
      :page-size.sync="pageSize"
      :layout="layout"
      :page-sizes="pageSizes"
      :total="total"
      v-bind="$attrs"
      prev-text="上一页"
      next-text="下一页"
      @current-change="handleCurrentChange"
    />
    <!--    @size-change="handleSizeChange"-->
    <el-button @click="lastPageClick" :disabled="total<=10">尾页</el-button>
    <span class="totaltext">共<i>{{total<10?1:(total%10===0?total/10:parseInt(total/10)+1)}}</i>页</span>
    <span class="totaltext">共<i>{{total}}</i>条记录</span>
  </div>
</template>

<script>
    import {scrollTo} from '@/utils/scroll-to'

    export default {
        name: 'Pagination',
        props: {
            total: {
                required: true,
                type: Number
            },
            page: {
                type: Number,
                default: 1
            },
            limit: {
                type: Number,
                default: 20
            },
            pageSizes: {
                type: Array,
                default() {
                    return [10, 20, 30, 50]
                }
            },
            layout: {
                type: String,
                //default: 'total, sizes, prev, pager, next, jumper'
                default: ' prev, pager, next'
            },
            background: {
                type: Boolean,
                default: true
            },
            autoScroll: {
                type: Boolean,
                default: true
            },
            hidden: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            currentPage: {
                get() {
                    return this.page
                },
                set(val) {
                    this.$emit('update:page', val)
                }
            },
            pageSize: {
                get() {
                    return this.limit
                },
                set(val) {
                    this.$emit('update:limit', val)
                }
            }
        },
        methods: {
            /* handleSizeChange(val) {
               this.$emit('pagination', { page: this.currentPage, limit: val })
               if (this.autoScroll) {
                 scrollTo(0, 800)
               }
             },*/
            handleCurrentChange(val) {
                this.$emit('pagination', {page: val, limit: this.pageSize})
                if (this.autoScroll) {
                    scrollTo(0, 800)
                }
            },
            firstPageClick() {
                this.currentPage = 1;
                this.$emit('pagination', {page: this.currentPage, limit: 10})
            },
            lastPageClick() {
                this.currentPage = parseInt(this.total / 10)+1;
                this.$emit('pagination', {page: this.currentPage, limit: 10})
            }
        }
    }
</script>

<style scoped>
  .pagination-container {
    background: #fff;
    /*padding: 32px 16px;*/
  }

  .pagination-container.hidden {
    display: none;
  }


</style>



// WEBPACK FOOTER //
// src/components/Pagination/index.vue